import React, { useEffect, useState, useRef, useContext} from 'react'
import { TabContext } from '../context/TabContext';
import { AppStateContext } from '../context/AppStateContext';
import QuestPage from './QuestPage/QuestPage'
import MapPage from './MapPage/MapPage';
import { BsLayoutTextSidebarReverse } from "react-icons/bs";
import { BsChatDots } from "react-icons/bs";
import { GrMapLocation } from "react-icons/gr";
import { FaRegQuestionCircle } from "react-icons/fa";
import { MdRefresh } from "react-icons/md";
import ChatPage from './ChatPage/ChatPage';
import FaqPage from './FaqPage/FaqPage';
import {QRCodeSVG} from 'qrcode.react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import CircularProgress from '@mui/material/CircularProgress';
import GameEndScreen from './GameEndScreen/GameEndScreen';

const MainPage = ({socket}) => {
    const {activeTab, setActiveTab} = useContext(TabContext);
    const {
        API_URL, 
        chatNotification, 
        questNotification, 
        setQuestNotification, 
        currentQuest, 
        teamData, 
        getTeamData, 
        teamToken,
        playTakenHintAudio,
    } = useContext(AppStateContext);
    const [loadMap, setLoadMap] = useState(false);
    const [showHintsMenu, setShowHintsMenu] = useState(false);
    const [clickedHintIds, setClickedHintIds] = useState([]);
    const [hintPenaltyPopup, setHintPenaltyPopup] = useState(null);
    const submenuRef = useRef(null);
    const hintPenaltyPopupTimerRef = useRef(null);
    const [isReconnecting, setIsReconnecting] = useState(false);
    const [questNumber, setQuestNumber] = useState('');
    const [showQR, setShowQR] = useState(false);
    const [showFaq, setShowFaq] = useState(false);

    const handleChange = (event, newValue) => {

        // wejście w dowolną zakładkę zamyka FAQ - tak samo jak menu podpowiedzi
        setShowFaq(false);

        if(newValue === "hints") {
            setShowHintsMenu(true);
        } else {
            console.log(newValue);
            setActiveTab(newValue);
            if (!loadMap && newValue === "map") {
                setLoadMap(true);
            }
        }
    };

    useEffect(() => {
        if (!showHintsMenu) return;

        function handleClickOutside(event) {
            if (submenuRef.current && !submenuRef.current.contains(event.target)) {
                setShowHintsMenu(false);
            }
        }

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [showHintsMenu]);

    useEffect(() => {
        if(questNotification && activeTab === 'quest') {
            setQuestNotification(false);
        }
    }, [questNotification, activeTab]);

    const tabCss = (tabValue) => ({
        color: activeTab === tabValue ? '#8dc6ff' : '#fff',
        boxShadow: activeTab === tabValue ? 'inset 0 4px 10px rgba(0, 0, 0, 0.8)' : 'none',
        border: activeTab === tabValue ? '1px solid rgba(255, 255, 255, 0.05)' : 'none',
        textTransform: 'none',
        fontSize: '1.2rem',
        fontWeight: activeTab === tabValue ? 600 : 300,
        minWidth: '70px',
        maxWidth: '70px',
        minHeight: '5.8rem',
        height: '5.8rem' 
    });

    const showHintPenaltyPopup = () => {
        clearTimeout(hintPenaltyPopupTimerRef.current);
        setHintPenaltyPopup('-50');
        hintPenaltyPopupTimerRef.current = setTimeout(() => setHintPenaltyPopup(null), 2600);
    };

    useEffect(() => {
        return () => clearTimeout(hintPenaltyPopupTimerRef.current);
    }, []);

    const handleHintClick = async (hint) => {
        setClickedHintIds(prev => [...prev, hint.id]);
        if (hint.id === 1) {
            showHintPenaltyPopup();
        }

        playTakenHintAudio();

        const hintItem = {
            id: hint.id,
            quest_id: currentQuest.id
        }

        await fetch(`${API_URL}/api/team/hint`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ teamToken, hintItem })
        })
        .then(res => res.json())
        .then(data => {
            if (data.success) {
                getTeamData(teamToken);
            } else {
                
            }
        })
        .catch(err => {
            console.error('Błądpodczas zapisywania podpowiedzi:', err);
        });


    };



    useEffect(() => {
        //console.log('clickedHintIds', clickedHintIds)
        setClickedHintIds([]);

    }, [currentQuest]);

    const handleReconnect = async () => {
        setIsReconnecting(true);

        if (!socket.connected) {
            //setIsReconnecting(true);
            socket.connect();

            // Poczekaj na połączenie
            socket.once('connect', async () => {
                console.log('Połączono ponownie');
                // Odśwież dane zespołu
                await getTeamData(teamToken);
                setIsReconnecting(false);
                // Opcjonalnie: przeładuj stronę
                // window.location.reload();
            });

            // Timeout na wypadek błędu połączenia
            setTimeout(() => {
                setIsReconnecting(false);
            }, 5000);
        } else {
            // Jeśli już połączony, odśwież dane
            //getTeamData(teamToken);

            await getTeamData(teamToken);
            setIsReconnecting(false);
        }
    };

    const disconnect = () => {
        if (socket.connected) {
            socket.disconnect();
        }
    };

    function nextQuest(number) {

        let nextQuestId;

        if(!number) {
            if(currentQuest.id === 'quest-0') {
                nextQuestId = 'quest-0a';
            }
            else if(currentQuest.id === 'quest-12') {
                nextQuestId = 'quest-12a';
            }
            else if(currentQuest.id === 'quest-0a') {
                nextQuestId = 'quest-1';
            }
            else if(currentQuest.id === 'quest-12a') {
                nextQuestId = 'quest-13';
            }
            else {
                nextQuestId = `quest-${parseInt(currentQuest.id.split('-')[1]) + 1}`;
            }
        }

        const nextMessage = {
            id: 'go-to-next-quest',
            quest_id: currentQuest.id,
            next_quest_id: number ? `quest-${number}` : nextQuestId,
            team_token: teamToken,
            points: currentQuest.points
        }

        socket.emit("message", nextMessage);

        setShowHintsMenu(false);
        setQuestNumber('');
    }

    const TOTAL_QUESTS = 22;
    const questSegment = currentQuest?.id.split('-')[1] || '0';
    const currentQuestNumber = parseInt(questSegment) || 0;
    const isSubQuest = /[a-zA-Z]/.test(questSegment);
    // +1 za każdy sub-quest który już minął (quest-0a i quest-12a)
    const questOffset = (currentQuestNumber > 0 ? 1 : 0) + (currentQuestNumber > 12 ? 1 : 0);
    const effectiveQuestNumber = currentQuestNumber + questOffset + (isSubQuest ? 1 : 0);
    const progressPercent = Math.min((effectiveQuestNumber / TOTAL_QUESTS) * 100, 100);

    return (
        <div className={`app__container`}>
            {hintPenaltyPopup && (
                <div
                    className='points-popup'
                    style={{
                        color: '#ff7d7d',
                        textShadow: '0 0 20px rgba(255, 94, 94, 0.7), 0 2px 8px rgba(0, 0, 0, 0.9)'
                    }}
                >
                    {hintPenaltyPopup} pkt
                </div>
            )}

            <div className="app__header header">

{/*
                <div className='header__stats'>
                    <div className='header__item header__points'>
                        {teamData?.points || 0} pkt.
                    </div>
                    
                    <div className='header__item header__timer'>
                        {teamData?.timer || 0} s.
                    </div>
                </div>
*/}

                <div className='header__tabs'>
                    <Tabs value={activeTab} onChange={handleChange}>
                        <Tab value="map" icon={<GrMapLocation className='app__header-icon'/>} label="Mapa" sx={tabCss('map')} />
                        <Tab 
                            value="quest" 
                            icon={
                                <span className="chat-icon" 
                                    style={{ marginBottom: '4px' }}>
                                    <BsLayoutTextSidebarReverse className='app__header-icon' />
                                        {questNotification && <span className="chat-icon-dot" />}
                                </span>
                            }
                            label="Zagadka" 
                            sx={tabCss('quest')} />
                        <Tab
                            value="chat"
                            icon={
                                <span className="chat-icon"
                                    style={{ marginBottom: '4px' }}>
                                    <BsChatDots className='app__header-icon' />
                                    {chatNotification && !chatNotification.read && <span className="chat-icon-dot" />}
                                </span>
                            }
                            label="Czat"
                            sx={tabCss('chat')}
                        />
                        <Tab value="hints" icon={<FaRegQuestionCircle className='app__header-icon' />} label="Pomoc" sx={{
                            ...tabCss('hints'),
                            //backgroundColor: 'rgba(255, 255, 255, 0.12)',
                        }} />
                    </Tabs>
                </div>
                
                {/*}
                <button 
                    onClick={handleReconnect}
                    className="reconnect-button"
                    disabled={isReconnecting}
                    title="Połącz ponownie"
                >
                    <MdRefresh 
                        className={`reconnect-icon ${isReconnecting ? 'spinning' : ''}`}
                        style={{ fontSize: '1.5rem' }}
                    />
                </button>
                */}

                {/* Progress bar */}
                {currentQuest && (
                    <>
                        <div className="quest-page__progress-bar-container">
                                {/* tło */}
                            <CircularProgress
                                variant="determinate"
                                value={100}
                                sx={{ color: "#ffffff23" }}
                                size={35}
                            />

                            {/* progress */}
                            <CircularProgress
                                variant="determinate"
                                value={progressPercent}
                                sx={{
                                    color: "#037ffc",
                                    position: "absolute",
                                    left: 0
                                }}
                                size={35}
                            />
                            <div className="quest-page__progress-bar-info">
                                <span>{effectiveQuestNumber}/{TOTAL_QUESTS}</span>
                            </div>
                        </div>
                    </>
                )}
                
            </div>

            {showHintsMenu && (
                <>
                    <div className="submenu-hints-bg"></div>
                    <div 
                        ref={submenuRef}
                        className="submenu-hints"
                    >
                        {currentQuest && currentQuest.hints && currentQuest.hints.length && 
                        <>
                            {currentQuest.hints.map((hint, index) => {
                                const isUsed = teamData?.hintsUsed?.some(
                                    el => el.id === hint.id && el.quest_id === currentQuest.id
                                );
                                const isClicked = clickedHintIds.includes(hint.id);
                                const isUnlocked = index === 0 || (() => {
                                    const prevHint = currentQuest.hints[index - 1];
                                    const prevUsed = teamData?.hintsUsed?.some(
                                        el => el.id === prevHint.id && el.quest_id === currentQuest.id
                                    );
                                    const prevClicked = clickedHintIds.includes(prevHint.id);
                                    return prevUsed || prevClicked;
                                })();
                                return (
                                    <button 
                                        key={hint.id} 
                                        className={`submenu-hints__btn `}
                                        disabled={isUsed || !isUnlocked}
                                        onClick={() => handleHintClick(hint)}>
                                            {isUsed || isClicked ? `${hint.text}` : <>Podpowiedź {hint.id} {hint.id === 1 && <span className="submenu-hints__pkt">(-50pkt)</span>}</>}
                                    </button>
                                )
                            })}
                          
                    
                        </>
                        }
                        <button className='submenu-hints__btn -next-quest' style={{marginTop: '20px'}} onClick={() => nextQuest()}>Idź do następnej zagadki <span style={{color: '#e74848ff'}}>(-100pkt)</span></button>

                        <div style={{marginTop: '20px', display: 'flex', gap: '10px', alignItems: 'center'}}>

                            {new URLSearchParams(window.location.search).get('test') === 'true' && (
                                <>
                                    <input
                                        type="text"
                                        placeholder="Nr zagadki"
                                        value={questNumber}
                                        onChange={(e) => setQuestNumber(e.target.value)}
                                        style={{
                                            padding: '8px',
                                            borderRadius: '4px',
                                            border: '1px solid #ccc',
                                            width: '100px',
                                            fontSize: '13px'
                                        }}
                                    />

                                    <button
                                        className='submenu-hints__btn -next-quest'
                                        style={{color: '#fff', fontSize: '13px', cursor: 'pointer', margin: '0'}}
                                        disabled={!questNumber}
                                        onClick={() => nextQuest(questNumber)}
                                    >
                                        Idź
                                        <span style={{color: '#e74848ff'}}>(-100pkt)</span>
                                    </button>
                                </>
                            )}


                        </div>

                        <button 
                                onClick={handleReconnect}
                                className="submenu-hints__btn reconnect-button"
                                disabled={isReconnecting}
                                title="Połącz ponownie"
                            >
                                Odśwież
                            <MdRefresh 
                                className={`reconnect-icon ${isReconnecting ? 'spinning' : ''}`}
                                style={{ fontSize: '1.5rem' }}
                            />
                        </button>

                        <button
                                className="submenu-hints__btn reconnect-button"
                                title="Udostępnij link do gry"
                                onClick={() => setShowQR(true)}
                            >
                                Udostępnij
                        </button>

                        <button
                                className="submenu-hints__btn -faq"
                                title="Najczęstsze pytania i rozwiązywanie problemów"
                                onClick={() => {
                                    setShowFaq(true);
                                    setShowHintsMenu(false);
                                }}
                            >
                                FAQ — pomoc w grze
                        </button>

                        {showQR && (
                            <div
                                onClick={() => setShowQR(false)}
                                className='gr-code__bg'
                            >
                                <div
                                    onClick={e => e.stopPropagation()}
                                    className='gr-code__container'
                                >
                                    <QRCodeSVG
                                        value={`${window.location.origin}/?token=${teamToken}&qr=true`}
                                        width="180"
                                        height="180"
                                        fgColor="#ffffff"
                                        bgColor="#1a1a1a"
                                    />
                                    <button
                                        onClick={() => setShowQR(false)}
                                        className='gr-code__close-btn'
                                    >
                                        Zamknij
                                    </button>
                                </div>
                            </div>
                        )}

                    </div>
                </>
            )}


             

            <div className='app__page'>
                <ChatPage socket={socket} visible={activeTab === "chat"} />
                <QuestPage socket={socket} visible={activeTab === "quest"} />
                <div className={`map-page`}>
                    {loadMap && <MapPage socket={socket} visible={activeTab === "map"} />}
                </div>
            </div>

            {showFaq && <FaqPage onClose={() => setShowFaq(false)} />}

            <div className='app__footer'>
                <div className='app__footer-container'>
                    {teamData?.name}: <span className='-points'>{teamData?.points || 0} pkt.</span>
                
                    

                    
                </div>
            </div>
            

    

        </div>
    )
}

export default MainPage